import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminAttribution from "@/pages/admin/AdminAttribution";

export const Route = createFileRoute("/admin/attribution")({
  head: () => pageHead("Admin \u2014 Attribution \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminAttribution,
});
